// extracted by mini-css-extract-plugin
export default {"statusCell":"styles_statusCell__6YbV1","downloadCell":"styles_downloadCell__IpRct"};